import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "w-full",
  style: {"margin-top":"2%"}
}
const _hoisted_2 = {
  for: "head",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_3 = {
  class: "w-full",
  style: {"margin-top":"4%"}
}
const _hoisted_4 = {
  for: "head",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_5 = {
  class: "w-full",
  style: {"margin-top":"4%"}
}
const _hoisted_6 = {
  for: "head",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_7 = {
  class: "w-full",
  style: {"margin-top":"4%"}
}
const _hoisted_8 = {
  for: "body",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_9 = {
  role: "status",
  style: {"display":"inline-block","margin-left":"47%","margin-top":"5%"}
}
const _hoisted_10 = ["aria-hidden"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "currentFill"
}, null, -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_15 = {
  class: "flex justify-between mt-2",
  style: {"margin-top":"4%"}
}

import { storeToRefs } from 'pinia'
import { patientStore } from '@/store/patient'
import { reactive, onMounted, ref } from 'vue'
import { sendEmail } from '@/../../EshJSLib/services/emailServices'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailModal',
  props: {
  reciever: String,
  recieverName: String
},
  emits: ["cancelMail", "alert"],
  setup(__props, { emit }) {

const props = __props;


const store = patientStore();
const { patient } = storeToRefs(store)
const mailTemp = reactive({topic: '', text: '', from: '', to: '', name: '', recName: ''});
const loading = ref(false);





onMounted(async () => {
  mailTemp.from = patient.value.paziente_email;
  mailTemp.to = props.reciever;
  mailTemp.name = patient.value.paziente_nome + ' ' + patient.value.paziente_cognome;
  mailTemp.recName = props.recieverName;
})

function sendMail() {
  const params = JSON.stringify(mailTemp);
  loading.value = true;
  sendEmail(params).then(response => {
    if('status' in response) {

      if(response.status == 200) {
        loading.value = false;
        emit('alert', 'success');
        return false;
      } else {
        loading.value = false;
        emit('alert', 'fail');
        return false;
      }
    }
    loading.value = false;
    emit('cancelMail');
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('A:')), 1),
      _withDirectives(_createElementVNode("input", {
        id: "head",
        name: "head",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mailTemp.to) = $event)),
        disabled: true,
        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
      }, null, 512), [
        [_vModelText, mailTemp.to]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('Da:')), 1),
      _withDirectives(_createElementVNode("input", {
        id: "head",
        name: "head",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mailTemp.from) = $event)),
        disabled: true,
        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
      }, null, 512), [
        [_vModelText, mailTemp.from]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Oggetto:')), 1),
      _withDirectives(_createElementVNode("input", {
        id: "head",
        name: "head",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mailTemp.topic) = $event)),
        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
      }, null, 512), [
        [_vModelText, mailTemp.topic]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Testo:')), 1),
      _withDirectives(_createElementVNode("textarea", {
        id: "body",
        name: "body",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mailTemp.text) = $event)),
        class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      }, null, 512), [
        [_vModelText, mailTemp.text]
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      (_openBlock(), _createElementBlock("svg", {
        "aria-hidden": !loading.value,
        class: "w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_13, 8, _hoisted_10)),
      _hoisted_14
    ], 512), [
      [_vShow, loading.value]
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancelMail'))),
        type: "button",
        class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
      }, _toDisplayString(_ctx.$t("Annulla")), 1),
      _createElementVNode("button", {
        onClick: sendMail,
        type: "button",
        class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      }, _toDisplayString(_ctx.$t("Inviare")), 1)
    ])
  ], 64))
}
}

})